<div class="px-2 sm:px-4 md:px-8 py-6">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance_wallet</mat-icon>
      Vita Wallet
      <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
        {{ environmentLabel }}
      </span>
    </h1>
    <div class="flex items-center gap-2 flex-wrap">

      <!-- Toggle maestro del servicio (VITA_SERVICIO) -->
      <div class="service-toggle-wrapper"
        [class.is-on]="serviceEnabled"
        [class.is-off]="!serviceEnabled"
        [style.opacity]="serviceLoading || serviceToggling ? '0.6' : '1'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
          [style.color]="serviceEnabled ? '#16a34a' : '#dc2626'">
          {{ serviceEnabled ? 'power_settings_new' : 'power_off' }}
        </mat-icon>
        <span class="service-toggle-label">
          Servicio:
          <b [style.color]="serviceEnabled ? '#166534' : '#b91c1c'">
            {{ serviceEnabled ? 'ACTIVO' : 'INACTIVO' }}
          </b>
        </span>
        <button type="button" class="service-toggle-switch"
          [class.on]="serviceEnabled"
          [disabled]="serviceLoading || serviceToggling"
          (click)="toggleServiceStatus()"
          [title]="serviceEnabled ? 'Desactivar servicio Vita' : 'Activar servicio Vita'">
          <span class="switch-knob"></span>
        </button>
        <mat-spinner *ngIf="serviceToggling" diameter="14"></mat-spinner>
      </div>

      <span *ngIf="!healthLoading && health" class="px-3 py-1 rounded-full text-xs font-bold inline-flex items-center gap-1.5"
        [style.background]="isOk ? '#f0fdf4' : '#fef2f2'"
        [style.color]="isOk ? '#15803d' : '#b91c1c'"
        [style.border]="isOk ? '1px solid #bbf7d0' : '1px solid #fecaca'">
        <span class="health-dot" [class.dot-ok]="isOk" [class.dot-down]="!isOk"></span>
        {{ isOk ? 'Operacional' : 'Con problemas' }}
      </span>
      <mat-spinner *ngIf="healthLoading" diameter="20"></mat-spinner>
      <button type="button" (click)="refresh()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 18px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.82rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">refresh</mat-icon>
        Refrescar
      </button>
    </div>
  </div>

  <!-- Banner grande si el servicio está desactivado -->
  <div *ngIf="!serviceLoading && !serviceEnabled"
    style="background: #fef2f2; border: 2px solid #fecaca; border-radius: 14px; padding: 14px 18px; margin-bottom: 16px; display: flex; align-items: center; gap: 12px;">
    <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #dc2626; flex-shrink: 0;">block</mat-icon>
    <div style="font-size: 0.95rem; font-weight: 800; color: #991b1b;">Servicio Vita Wallet desactivado</div>
  </div>

  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ environmentLabel }}
  </span>

  <!-- Estado conexión -->
  <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-4">
    <div (click)="toggleSection('health')"
      class="flex items-center justify-between px-3 py-2 cursor-pointer xl:cursor-default"
      [style.background]="expandedSections.has('health') ? '#f0fdf4' : 'white'">
      <div class="flex items-center gap-1.5">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">monitoring</mat-icon>
        <span style="font-size: 0.8rem; font-weight: 700; color: #1e5a3f;">Estado de conexión</span>

        <ng-container *ngIf="!healthError && !healthLoading && health">
          <span class="hidden xl:inline-flex items-center gap-1 ml-2 px-2 py-0.5 rounded-full"
            [style.background]="isOk ? '#dcfce7' : '#fee2e2'">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;" [style.color]="isOk ? '#16a34a' : '#dc2626'">
              {{ isOk ? 'check_circle' : 'cancel' }}
            </mat-icon>
            <span style="font-size: 0.7rem; font-weight: 700;" [style.color]="isOk ? '#15803d' : '#b91c1c'">{{ isOk ? 'OK' : 'ERROR' }}</span>
          </span>
          <span class="hidden xl:inline-flex items-center gap-1 ml-1 px-2 py-0.5 rounded-full" style="background: #f3f4f6;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">dns</mat-icon>
            <span style="font-size: 0.7rem; font-weight: 700; color: #1e5a3f;">{{ environmentLabel }}</span>
          </span>
          <span class="hidden xl:inline-flex items-center gap-1 ml-1 px-2 py-0.5 rounded-full" style="background: #f3f4f6;" [ngClass]="latencyClass">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">bolt</mat-icon>
            <span style="font-size: 0.7rem; font-weight: 700;">{{ health.latencyMs }} ms</span>
          </span>
          <span class="hidden xl:inline-flex items-center gap-1 ml-1 px-2 py-0.5 rounded-full" style="background: #f3f4f6;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">schedule</mat-icon>
            <span style="font-size: 0.7rem; font-weight: 700; color: #374151;">{{ health.timestamp | date:'HH:mm:ss' }}</span>
          </span>
        </ng-container>
      </div>
      <mat-icon class="xl:hidden"
        [style.transform]="expandedSections.has('health') ? 'rotate(180deg)' : 'rotate(0)'"
        style="font-size: 18px; width: 18px; height: 18px; transition: transform 0.2s ease;">expand_more</mat-icon>
    </div>

    <!-- Mobile: chips en fila aparte -->
    <div class="xl:hidden px-3 pb-3"
      [class.hidden]="!expandedSections.has('health')">
      <div *ngIf="healthError" style="display: flex; align-items: center; gap: 6px; background: #fef2f2; padding: 8px 10px; border-radius: 8px; border: 1px solid #fecaca;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">warning</mat-icon>
        <span style="font-size: 0.75rem; font-weight: 600; color: #b91c1c;">{{ healthError }}</span>
      </div>
      <div *ngIf="!healthError && !healthLoading && health" class="flex flex-wrap gap-1.5">
        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full"
          [style.background]="isOk ? '#dcfce7' : '#fee2e2'">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;" [style.color]="isOk ? '#16a34a' : '#dc2626'">
            {{ isOk ? 'check_circle' : 'cancel' }}
          </mat-icon>
          <span style="font-size: 0.7rem; font-weight: 700;" [style.color]="isOk ? '#15803d' : '#b91c1c'">{{ isOk ? 'OK' : 'ERROR' }}</span>
        </span>
        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full" style="background: #f3f4f6;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">dns</mat-icon>
          <span style="font-size: 0.7rem; font-weight: 700; color: #1e5a3f;">{{ environmentLabel }}</span>
        </span>
        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full" style="background: #f3f4f6;" [ngClass]="latencyClass">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;">bolt</mat-icon>
          <span style="font-size: 0.7rem; font-weight: 700;">{{ health.latencyMs }} ms</span>
        </span>
        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full" style="background: #f3f4f6;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">schedule</mat-icon>
          <span style="font-size: 0.7rem; font-weight: 700; color: #374151;">{{ health.timestamp | date:'HH:mm:ss' }}</span>
        </span>
      </div>
      <div *ngIf="healthLoading" class="flex justify-center py-2"><mat-spinner diameter="20"></mat-spinner></div>
      <div *ngIf="!isOk && health?.message" style="font-size: 0.7rem; color: #b91c1c; margin-top: 6px; font-weight: 600;">{{ health?.message }}</div>
    </div>

    <!-- Desktop: errores/loading inline en segunda fila cuando aplica -->
    <div class="hidden xl:block">
      <div *ngIf="healthError" class="px-3 pb-2">
        <div style="display: flex; align-items: center; gap: 6px; background: #fef2f2; padding: 6px 10px; border-radius: 8px; border: 1px solid #fecaca;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">warning</mat-icon>
          <span style="font-size: 0.75rem; font-weight: 600; color: #b91c1c;">{{ healthError }}</span>
        </div>
      </div>
      <div *ngIf="healthLoading" class="flex justify-center py-2"><mat-spinner diameter="20"></mat-spinner></div>
      <div *ngIf="!isOk && health?.message && !healthError" class="px-3 pb-2" style="font-size: 0.7rem; color: #b91c1c; font-weight: 600;">{{ health?.message }}</div>
    </div>
  </div>

  <!-- Saldos -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
    <div (click)="toggleSection('balances')"
      class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
      [style.background]="expandedSections.has('balances') ? '#f0fdf4' : 'white'">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D;">savings</mat-icon>
        <span style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">Saldos en Vita</span>
        <span *ngIf="walletViews.length > 0" class="ml-1 text-xs font-semibold bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
          {{ walletViews.length }}
        </span>
      </div>
      <mat-icon class="xl:hidden"
        [style.transform]="expandedSections.has('balances') ? 'rotate(180deg)' : 'rotate(0)'"
        style="transition: transform 0.2s ease;">expand_more</mat-icon>
    </div>

    <div class="px-4 pb-4 xl:px-5 xl:pb-5"
      [class.hidden]="!expandedSections.has('balances')" [class.xl:block]="true">

      <div *ngIf="walletsError" style="display: flex; align-items: center; gap: 8px; background: #fef2f2; padding: 12px 16px; border-radius: 10px; border: 1px solid #fecaca;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">warning</mat-icon>
        <span style="font-size: 0.85rem; font-weight: 600; color: #b91c1c;">{{ walletsError }}</span>
      </div>
      <div *ngIf="walletsLoading" class="flex justify-center py-6"><mat-spinner diameter="28"></mat-spinner></div>
      <div *ngIf="!walletsLoading && !walletsError && walletViews.length === 0"
        style="display: flex; align-items: center; gap: 8px; justify-content: center; background: #fef3c7; padding: 10px 16px; border-radius: 10px; border: 1px solid #fde68a;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b;">info</mat-icon>
        <span style="font-size: 0.82rem; font-weight: 600; color: #92400e;">No hay wallets disponibles</span>
      </div>

      <div *ngIf="!walletsLoading && walletViews.length > 0"
        class="grid gap-3 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        <div *ngFor="let w of walletViews; trackBy: trackByWalletUuid"
          style="border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; background: white;">
          <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 8px 12px; border-bottom: 1px solid #bbf7d0;"
            class="flex items-center gap-1.5">
            <mat-icon style="color: #1C593D; font-size: 16px; width: 16px; height: 16px;">account_balance</mat-icon>
            <span style="font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #1e5a3f;">{{ w.item.type || 'Wallet' }}</span>
            <span *ngIf="w.item.attributes?.is_master"
              class="ml-auto px-1.5 py-0 rounded-full"
              style="background: #1C593D; color: white; font-size: 0.6rem; font-weight: 700; letter-spacing: 0.3px;">MASTER</span>
            <button *ngIf="w.item.attributes?.is_master" type="button"
              (click)="openConvertDialog(w)"
              title="Convertir saldo entre monedas (fiat↔cripto, ej. CLP→USDT o USDT→USD)"
              class="ml-1"
              style="display: inline-flex; align-items: center; gap: 3px; background: white; color: #1C593D; border: 1px solid #1C593D; border-radius: 999px; font-size: 0.6rem; font-weight: 700; padding: 1px 8px; cursor: pointer;">
              <mat-icon style="font-size: 12px; width: 12px; height: 12px;">swap_horiz</mat-icon>
              Convertir
            </button>
          </div>
          <div class="p-3">
            <div *ngIf="w.balances.length === 0"
              style="font-size: 0.75rem; color: #6b7280; font-style: italic; padding: 4px 0;">Sin saldos reportados</div>
            <div *ngIf="w.balances.length > 0" class="grid grid-cols-2 gap-1.5">
              <div *ngFor="let b of w.balances; trackBy: trackByBalanceCurrency"
                (click)="w.item.attributes.is_master ? openConvertDialog(w, b.currency) : null"
                [style.cursor]="w.item.attributes.is_master ? 'pointer' : 'default'"
                [title]="w.item.attributes.is_master ? 'Convertir desde ' + b.currency : ''"
                style="background: #f3f4f6; border-radius: 8px; padding: 6px 8px; display: flex; flex-direction: column; gap: 1px;">
                <span style="font-size: 0.6rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; color: #6b7280;">{{ b.currency }}</span>
                <span style="font-size: 0.88rem; font-weight: 800; color: #1e5a3f;">{{ b.amount | number:'1.2-8' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Catálogo: Países / Bancos -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div (click)="toggleSection('catalog')"
      class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
      [style.background]="expandedSections.has('catalog') ? '#f0fdf4' : 'white'">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D;">public</mat-icon>
        <span style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">Catálogo de países y bancos</span>
      </div>
      <mat-icon class="xl:hidden"
        [style.transform]="expandedSections.has('catalog') ? 'rotate(180deg)' : 'rotate(0)'"
        style="transition: transform 0.2s ease;">expand_more</mat-icon>
    </div>

    <div class="px-4 pb-4 xl:px-5 xl:pb-5"
      [class.hidden]="!expandedSections.has('catalog')" [class.xl:block]="true">

      <!-- Header + acciones globales (diagnóstico) -->
      <div class="flex gap-2 mb-4 flex-wrap items-center justify-between">
        <div class="flex items-center gap-2">
          <mat-icon style="color: #1C593D;">flag</mat-icon>
          <span style="font-weight: 700; color: #1e5a3f; font-size: 0.9rem;">Países permitidos</span>
          <span class="text-xs font-bold rounded-full px-2 py-0.5"
            style="background: #ecfdf5; color: #1C593D;">
            {{ countriesTotal }}
          </span>
        </div>

        <div class="flex gap-2 flex-wrap">
          <button type="button" (click)="openDiagnostics()" [disabled]="diagnosticsLoading"
            title="Ver a qué Vita (prod/stage) estamos conectados y qué variantes publica en vivo"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 14px; background: white; color: #1e5a3f; border: 1px solid #1e5a3f; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
            [style.opacity]="diagnosticsLoading ? 0.6 : 1">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">health_and_safety</mat-icon>
            {{ diagnosticsLoading ? 'Cargando…' : 'Diagnóstico' }}
          </button>
        </div>
      </div>

      <!-- ========= PAÍSES ========= -->
      <div>

        <!-- Filtros países -->
        <div class="flex flex-wrap gap-2 mb-4 items-center">
          <div style="display: flex; align-items: center; gap: 6px; background: white; border: 1px solid #d1d5db; border-radius: 10px; padding: 6px 12px; min-width: 240px; flex: 1;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">search</mat-icon>
            <input type="text" [(ngModel)]="countriesSearch" (input)="onCountriesSearchInput()"
              placeholder="Buscar por nombre, código o moneda…"
              style="flex: 1; border: none; outline: none; font-size: 0.85rem; color: #374151; background: transparent;" />
            <button *ngIf="countriesSearch" type="button" (click)="countriesSearch=''; onCountriesSearchInput()"
              style="display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border: none; background: transparent; color: #9ca3af; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">close</mat-icon>
            </button>
          </div>

          <select [(ngModel)]="countriesActive" (change)="onCountriesFilterChange()"
            style="padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 10px; background: white; font-size: 0.82rem; color: #374151; cursor: pointer;">
            <option value="">Todos los estados</option>
            <option value="true">Solo activos</option>
            <option value="false">Solo inactivos</option>
          </select>

          <button type="button" (click)="clearCountriesFilters()"
            style="display: inline-flex; align-items: center; gap: 4px; padding: 7px 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">clear</mat-icon>
            Limpiar
          </button>

          <button type="button" (click)="openAddCountryDialog()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 7px 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; margin-left: auto;"
            onmouseover="this.style.background='#15452f'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">add_location_alt</mat-icon>
            Agregar país
          </button>
        </div>

        <!-- Tabla países (desktop) -->
        <div class="hidden md:block" style="border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden;">
          <table style="width: 100%; border-collapse: collapse; font-size: 0.85rem;">
            <thead>
              <tr style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 2px solid #bbf7d0;">
                <th style="text-align: left; padding: 10px 14px; color: #1e5a3f; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">País</th>
                <th style="text-align: left; padding: 10px 14px; color: #1e5a3f; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">Código</th>
                <th style="text-align: left; padding: 10px 14px; color: #1e5a3f; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">Moneda</th>
                <th style="text-align: center; padding: 10px 14px; color: #1e5a3f; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">Payin</th>
                <th style="text-align: center; padding: 10px 14px; color: #1e5a3f; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">Payout</th>
                <th style="text-align: center; padding: 10px 14px; color: #1e5a3f; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of countries; let i = index; trackBy: trackByCountryId"
                [style.background]="i % 2 === 0 ? 'white' : '#fafafa'"
                style="border-bottom: 1px solid #f3f4f6;">
                <td style="padding: 10px 14px;">
                  <img [src]="'https://flagcdn.com/24x18/' + c.code.toLowerCase() + '.png'"
                    [alt]="c.code" width="24" height="18"
                    style="display: inline-block; vertical-align: middle; margin-right: 8px; border-radius: 2px; border: 1px solid #e5e7eb;"
                    onerror="this.style.display='none'" />
                  <span style="font-weight: 600; color: #374151;">{{ c.name }}</span>
                </td>
                <td style="padding: 10px 14px;">
                  <span style="font-family: monospace; font-weight: 700; background: #f3f4f6; color: #1e5a3f; padding: 2px 8px; border-radius: 6px;">{{ c.code }}</span>
                </td>
                <td style="padding: 10px 14px; text-transform: uppercase; font-weight: 600; color: #6b7280;">{{ c.currency }}</td>
                <td style="text-align: center; padding: 10px 14px;">
                  <mat-icon *ngIf="c.supportsPayin" style="font-size: 18px; width: 18px; height: 18px; color: #16a34a;">check_circle</mat-icon>
                  <mat-icon *ngIf="!c.supportsPayin" style="font-size: 18px; width: 18px; height: 18px; color: #d1d5db;">remove_circle</mat-icon>
                </td>
                <td style="text-align: center; padding: 10px 14px;">
                  <mat-icon *ngIf="c.supportsPayout" style="font-size: 18px; width: 18px; height: 18px; color: #16a34a;">check_circle</mat-icon>
                  <mat-icon *ngIf="!c.supportsPayout" style="font-size: 18px; width: 18px; height: 18px; color: #d1d5db;">remove_circle</mat-icon>
                </td>
                <td style="text-align: center; padding: 10px 14px;">
                  <div style="display: inline-flex; align-items: center; gap: 6px;">
                    <button type="button" (click)="toggleCountryActive(c)"
                      [disabled]="deletingCountryId === c.id"
                      [title]="c.isActive ? 'Desactivar país (se preserva la configuración)' : 'Reactivar país'"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 600; font-size: 0.75rem; cursor: pointer;"
                      [style.background]="c.isActive ? 'white' : '#ecfdf5'"
                      [style.color]="c.isActive ? '#b45309' : '#166534'"
                      [style.border]="c.isActive ? '1px solid #fcd34d' : '1px solid #86efac'"
                      [style.opacity]="deletingCountryId === c.id ? '0.5' : '1'">
                      <mat-spinner *ngIf="deletingCountryId === c.id" diameter="14"></mat-spinner>
                      <mat-icon *ngIf="deletingCountryId !== c.id" style="font-size: 14px; width: 14px; height: 14px;">
                        {{ c.isActive ? 'toggle_on' : 'toggle_off' }}
                      </mat-icon>
                      {{ c.isActive ? 'Desactivar' : 'Activar' }}
                    </button>
                    <button *ngIf="c.code === 'CO'" type="button" (click)="openRailColombiaConfig(c)"
                      title="Configurar tasas USD/COP (Rail Colombia)"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1d4ed8; border: 1px solid #bfdbfe;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">tune</mat-icon>
                      USD/COP
                    </button>
                    <button *ngIf="c.code === 'PE'" type="button" (click)="openRailPeruConfig(c)"
                      title="Configurar tasas USD/PEN (Rail Perú)"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1d4ed8; border: 1px solid #bfdbfe;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">tune</mat-icon>
                      USD/PEN
                    </button>
                    <button *ngIf="c.code === 'PE'" type="button" (click)="openRailVesPenConfig(c)"
                      title="Configurar VES→PEN (paga con saldo VES)"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #a16207; border: 1px solid #fde68a;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
                      VES/PEN
                    </button>
                    <button *ngIf="c.code === 'PE'" type="button" (click)="openRailClpPenConfig(c)"
                      title="Configurar CLP→PEN (paga con saldo CLP)"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #0f766e; border: 1px solid #99f6e4;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
                      CLP/PEN
                    </button>
                    <button *ngIf="c.code === 'CO'" type="button" (click)="openClpCopConfig(c)"
                      title="Configurar CLP→COP (paga con saldo CLP)"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #0f766e; border: 1px solid #99f6e4;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
                      CLP/COP
                    </button>
                    <button *ngIf="c.code === 'CO'" type="button" (click)="openVesCopConfig(c)"
                      title="Configurar VES→COP (paga con saldo VES)"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #a16207; border: 1px solid #fde68a;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
                      VES/COP
                    </button>
                    <button *ngIf="c.code === 'CO'" type="button" (click)="openClientSim(c)"
                      title="Simular como lo ve el cliente"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1C593D; border: 1px solid #86efac;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">visibility</mat-icon>
                      Cliente
                    </button>
                    <button *ngIf="c.code === 'PE'" type="button" (click)="openPeruClientSim(c)"
                      title="Simular como lo ve el cliente"
                      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1C593D; border: 1px solid #86efac;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">visibility</mat-icon>
                      Cliente
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!countriesLoading && countries.length === 0">
                <td colspan="6" style="padding: 32px; text-align: center; color: #6b7280; font-size: 0.85rem;">
                  <mat-icon style="font-size: 32px; width: 32px; height: 32px; color: #d1d5db; display: block; margin: 0 auto 8px;">search_off</mat-icon>
                  No se encontraron países con esos filtros
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Cards países (mobile) -->
        <div class="md:hidden flex flex-col gap-2">
          <div *ngFor="let c of countries; trackBy: trackByCountryId" style="border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px; background: white;">
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center gap-2">
                <img [src]="'https://flagcdn.com/32x24/' + c.code.toLowerCase() + '.png'"
                  [alt]="c.code" width="32" height="24"
                  style="border-radius: 3px; border: 1px solid #e5e7eb;"
                  onerror="this.style.display='none'" />
                <div>
                  <div style="font-weight: 700; color: #374151;">{{ c.name }}</div>
                  <div style="font-size: 0.72rem; color: #6b7280;"><span style="font-family: monospace; font-weight: 700;">{{ c.code }}</span> · {{ c.currency | uppercase }}</div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <button type="button" (click)="toggleCountryActive(c)"
                  [disabled]="deletingCountryId === c.id"
                  [title]="c.isActive ? 'Desactivar país (se preserva la configuración)' : 'Reactivar país'"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 600; font-size: 0.75rem; cursor: pointer;"
                  [style.background]="c.isActive ? 'white' : '#ecfdf5'"
                  [style.color]="c.isActive ? '#b45309' : '#166534'"
                  [style.border]="c.isActive ? '1px solid #fcd34d' : '1px solid #86efac'"
                  [style.opacity]="deletingCountryId === c.id ? '0.5' : '1'">
                  <mat-spinner *ngIf="deletingCountryId === c.id" diameter="14"></mat-spinner>
                  <mat-icon *ngIf="deletingCountryId !== c.id" style="font-size: 14px; width: 14px; height: 14px;">
                    {{ c.isActive ? 'toggle_on' : 'toggle_off' }}
                  </mat-icon>
                  {{ c.isActive ? 'Desactivar' : 'Activar' }}
                </button>
                <button *ngIf="c.code === 'CO'" type="button" (click)="openRailColombiaConfig(c)"
                  title="Configurar tasas USD/COP (Rail Colombia)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1d4ed8; border: 1px solid #bfdbfe;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">tune</mat-icon>
                  USD/COP
                </button>
                <button *ngIf="c.code === 'PE'" type="button" (click)="openRailPeruConfig(c)"
                  title="Configurar tasas USD/PEN (Rail Perú)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1d4ed8; border: 1px solid #bfdbfe;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">tune</mat-icon>
                  USD/PEN
                </button>
                <button *ngIf="c.code === 'PE'" type="button" (click)="openRailVesPenConfig(c)"
                  title="Configurar VES→PEN (paga con saldo VES)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #a16207; border: 1px solid #fde68a;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
                  VES/PEN
                </button>
                <button *ngIf="c.code === 'CO'" type="button" (click)="openClpCopConfig(c)"
                  title="Configurar CLP→COP (paga con saldo CLP)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #0f766e; border: 1px solid #99f6e4;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
                  CLP/COP
                </button>
                <button *ngIf="c.code === 'CO'" type="button" (click)="openVesCopConfig(c)"
                  title="Configurar VES→COP (paga con saldo VES)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #a16207; border: 1px solid #fde68a;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
                  VES/COP
                </button>
                <button *ngIf="c.code === 'CO'" type="button" (click)="openClientSim(c)"
                  title="Simular como lo ve el cliente"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1C593D; border: 1px solid #86efac;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">visibility</mat-icon>
                  Cliente
                </button>
                <button *ngIf="c.code === 'PE'" type="button" (click)="openPeruClientSim(c)"
                  title="Simular como lo ve el cliente"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; background: #fff; color: #1C593D; border: 1px solid #86efac;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">visibility</mat-icon>
                  Cliente
                </button>
              </div>
            </div>
            <div class="flex gap-3 text-xs text-gray-500">
              <span>Payin: <mat-icon [style.color]="c.supportsPayin ? '#16a34a' : '#d1d5db'" style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle;">{{ c.supportsPayin ? 'check' : 'close' }}</mat-icon></span>
              <span>Payout: <mat-icon [style.color]="c.supportsPayout ? '#16a34a' : '#d1d5db'" style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle;">{{ c.supportsPayout ? 'check' : 'close' }}</mat-icon></span>
            </div>
          </div>
        </div>

        <div *ngIf="countriesLoading" class="flex justify-center py-6"><mat-spinner diameter="24"></mat-spinner></div>
        <div *ngIf="countriesError" style="margin-top: 12px; background: #fef2f2; padding: 10px 16px; border-radius: 10px; border: 1px solid #fecaca;">
          <span style="font-size: 0.82rem; color: #b91c1c; font-weight: 600;">{{ countriesError }}</span>
        </div>

        <!-- Paginador países -->
        <div class="flex items-center justify-between mt-4 flex-wrap gap-2" *ngIf="countriesTotal > 0">
          <div class="flex items-center gap-3 flex-wrap">
            <span style="font-size: 0.78rem; color: #6b7280; font-weight: 600;">{{ countriesRangeLabel }}</span>
            <div class="flex items-center gap-2" *ngIf="countriesTotal > 20">
              <span style="font-size: 0.72rem; color: #9ca3af; font-weight: 600;">Por página:</span>
              <select [(ngModel)]="countriesLimit" (change)="onCountriesPageSizeChange()"
                style="padding: 4px 10px; border: 1px solid #d1d5db; border-radius: 8px; background: white; font-size: 0.78rem; color: #374151; cursor: pointer;">
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
              </select>
            </div>
          </div>
          <div class="flex items-center gap-1">
            <button type="button" (click)="goCountriesPage(1)" [disabled]="countriesPage <= 1" title="Primera"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white;"
              [style.opacity]="countriesPage <= 1 ? '0.4' : '1'"
              [style.cursor]="countriesPage <= 1 ? 'not-allowed' : 'pointer'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">first_page</mat-icon>
            </button>
            <button type="button" (click)="goCountriesPage(countriesPage - 1)" [disabled]="countriesPage <= 1" title="Anterior"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white;"
              [style.opacity]="countriesPage <= 1 ? '0.4' : '1'"
              [style.cursor]="countriesPage <= 1 ? 'not-allowed' : 'pointer'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">chevron_left</mat-icon>
            </button>
            <span style="font-size: 0.8rem; color: #374151; font-weight: 700; padding: 0 10px;">
              {{ countriesPage }} <span style="color: #9ca3af;">de</span> {{ countriesTotalPages }}
            </span>
            <button type="button" (click)="goCountriesPage(countriesPage + 1)" [disabled]="countriesPage >= countriesTotalPages" title="Siguiente"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white;"
              [style.opacity]="countriesPage >= countriesTotalPages ? '0.4' : '1'"
              [style.cursor]="countriesPage >= countriesTotalPages ? 'not-allowed' : 'pointer'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">chevron_right</mat-icon>
            </button>
            <button type="button" (click)="goCountriesPage(countriesTotalPages)" [disabled]="countriesPage >= countriesTotalPages" title="Última"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white;"
              [style.opacity]="countriesPage >= countriesTotalPages ? '0.4' : '1'"
              [style.cursor]="countriesPage >= countriesTotalPages ? 'not-allowed' : 'pointer'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">last_page</mat-icon>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Tasas y precios -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mt-5">
    <div (click)="toggleSection('prices')"
      class="flex items-center justify-between p-4 xl:p-5 cursor-pointer xl:cursor-default"
      [style.background]="expandedSections.has('prices') ? '#f0fdf4' : 'white'">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D;">trending_up</mat-icon>
        <span style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">Tasas y precios</span>
        <span *ngIf="pricesValidUntil" class="px-2 py-0.5 rounded-full text-xs font-bold ml-2"
          [ngClass]="'freshness-' + pricesValidUntilClass">
          {{ pricesValidUntilLabel }}
        </span>
      </div>
      <mat-icon class="xl:hidden"
        [style.transform]="expandedSections.has('prices') ? 'rotate(180deg)' : 'rotate(0)'"
        style="transition: transform 0.2s ease;">expand_more</mat-icon>
    </div>

    <div class="px-4 pb-4 xl:px-5 xl:pb-5"
      [class.hidden]="!expandedSections.has('prices')" [class.xl:block]="true">

      <!-- Header info row -->
      <div class="flex items-center justify-between flex-wrap gap-2 mb-4">
        <div style="display: flex; align-items: center; gap: 8px; background: #eff6ff; padding: 8px 12px; border-radius: 10px; border: 1px solid #bfdbfe;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">info</mat-icon>
          <span style="font-size: 0.76rem; font-weight: 600; color: #1e40af;">
            Vita calcula precios por <b>país destino</b>, no por banco. Solo los <b>payins</b> varían por <b>payment_method</b>.
          </span>
        </div>
        <div class="flex items-center gap-2">
          <span *ngIf="pricesFreshnessMinutes !== null" style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">
            Actualizado hace {{ pricesFreshnessMinutes }} min · auto-refresh 5 min
          </span>
          <mat-spinner *ngIf="pricesLoading" diameter="18"></mat-spinner>
          <button type="button" (click)="refreshPrices()" [disabled]="pricesLoading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 7px 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.78rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="pricesLoading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: white;">sync</mat-icon>
            Sincronizar
          </button>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="pricesError" style="background: #fef2f2; padding: 10px 14px; border-radius: 10px; border: 1px solid #fecaca; margin-bottom: 12px;">
        <span style="font-size: 0.82rem; color: #b91c1c; font-weight: 600;">{{ pricesError }}</span>
      </div>

      <!-- Tabs -->
      <div class="flex gap-2 mb-3 flex-wrap">
        <button type="button" (click)="onPricesTabChange('withdrawal')"
          [style.background]="pricesTab === 'withdrawal' ? '#1C593D' : 'white'"
          [style.color]="pricesTab === 'withdrawal' ? 'white' : '#374151'"
          [style.border]="pricesTab === 'withdrawal' ? 'none' : '1px solid #d1d5db'"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;">call_made</mat-icon>
          Retiros
          <span class="text-xs font-bold rounded-full px-2 py-0.5"
            [style.background]="pricesTab === 'withdrawal' ? '#ecfdf5' : '#f3f4f6'"
            [style.color]="pricesTab === 'withdrawal' ? '#1C593D' : '#6b7280'">
            {{ filteredWithdrawalRows.length }}
          </span>
        </button>
        <button type="button" (click)="onPricesTabChange('vitasent')"
          [style.background]="pricesTab === 'vitasent' ? '#1C593D' : 'white'"
          [style.color]="pricesTab === 'vitasent' ? 'white' : '#374151'"
          [style.border]="pricesTab === 'vitasent' ? 'none' : '1px solid #d1d5db'"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;">swap_horiz</mat-icon>
          Transferencias Vita
          <span class="text-xs font-bold rounded-full px-2 py-0.5"
            [style.background]="pricesTab === 'vitasent' ? '#ecfdf5' : '#f3f4f6'"
            [style.color]="pricesTab === 'vitasent' ? '#1C593D' : '#6b7280'">
            {{ filteredVitaSentRows.length }}
          </span>
        </button>
        <button type="button" (click)="onPricesTabChange('payins')"
          [style.background]="pricesTab === 'payins' ? '#1C593D' : 'white'"
          [style.color]="pricesTab === 'payins' ? 'white' : '#374151'"
          [style.border]="pricesTab === 'payins' ? 'none' : '1px solid #d1d5db'"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;">call_received</mat-icon>
          Payins
          <span class="text-xs font-bold rounded-full px-2 py-0.5"
            [style.background]="pricesTab === 'payins' ? '#ecfdf5' : '#f3f4f6'"
            [style.color]="pricesTab === 'payins' ? '#1C593D' : '#6b7280'">
            {{ filteredPayinRows.length }}
          </span>
        </button>
      </div>

      <!-- Filtros -->
      <div class="flex flex-wrap gap-2 mb-3 items-center">
        <div style="display: flex; align-items: center; gap: 6px; background: white; border: 1px solid #d1d5db; border-radius: 10px; padding: 6px 12px; min-width: 200px; flex: 1;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">search</mat-icon>
          <input type="text" [(ngModel)]="pricesSearch" (ngModelChange)="onPricesFilterChange()" placeholder="Buscar país o moneda…"
            style="flex: 1; border: none; outline: none; font-size: 0.85rem; color: #374151; background: transparent;" />
          <button *ngIf="pricesSearch" type="button" (click)="pricesSearch=''; onPricesFilterChange()"
            style="display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border: none; background: transparent; color: #9ca3af; cursor: pointer;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">close</mat-icon>
          </button>
        </div>

        <select [(ngModel)]="pricesCountryFilter" (ngModelChange)="onPricesFilterChange()"
          style="padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 10px; background: white; font-size: 0.82rem; color: #374151; cursor: pointer;">
          <option value="">Todos los países</option>
          <option *ngFor="let c of countryOptions; trackBy: trackByCountryCode" [value]="c.code">{{ c.name }} ({{ c.code }})</option>
        </select>

        <select *ngIf="pricesTab !== 'payins'" [(ngModel)]="pricesSourceCurrencyFilter" (ngModelChange)="onPricesFilterChange()"
          style="padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 10px; background: white; font-size: 0.82rem; color: #374151; cursor: pointer;">
          <option value="">Todas las monedas origen</option>
          <option *ngFor="let c of sourceCurrencyOptions; trackBy: trackByString" [value]="c">{{ c | uppercase }}</option>
        </select>

        <select *ngIf="pricesTab === 'payins'" [(ngModel)]="pricesPaymentMethodFilter" (ngModelChange)="onPricesFilterChange()"
          style="padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 10px; background: white; font-size: 0.82rem; color: #374151; cursor: pointer;">
          <option value="">Todos los métodos</option>
          <option *ngFor="let pm of paymentMethodOptions; trackBy: trackByString" [value]="pm">{{ pm }}</option>
        </select>

        <button type="button" (click)="clearPricesFilters()"
          style="display: inline-flex; align-items: center; gap: 4px; padding: 7px 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">clear</mat-icon>
          Limpiar
        </button>

      </div>

      <!-- Tab: Retiros -->
      <div *ngIf="pricesTab === 'withdrawal'" style="border: 1px solid #e5e7eb; border-radius: 12px; overflow: auto; max-height: 520px;">
        <table style="width: 100%; border-collapse: collapse; font-size: 0.82rem;">
          <thead>
            <tr style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 2px solid #bbf7d0; position: sticky; top: 0; z-index: 1;">
              <th style="text-align: left; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Destino</th>
              <th style="text-align: left; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Tasa</th>
              <th style="text-align: right; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Fee</th>
              <th style="text-align: right; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Mín. envío</th>
              <th style="text-align: center; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Plazo</th>
              <th style="text-align: center; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase; background: #ecfdf5;">Simular</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of filteredWithdrawalRows; let i = index; trackBy: trackByWithdrawalRow" [style.background]="i % 2 === 0 ? 'white' : '#fafafa'" style="border-bottom: 1px solid #f3f4f6;">
              <td style="padding: 8px 12px; font-weight: 600; color: #374151;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <img *ngIf="r.flagIso as iso" [src]="'https://flagcdn.com/20x15/' + iso + '.png'" alt="" width="20" height="15"
                    style="border-radius: 2px; border: 1px solid #e5e7eb; flex-shrink: 0;" onerror="this.style.display='none'" />
                  <mat-icon *ngIf="!r.flagIso" style="font-size: 16px; width: 16px; height: 16px; color: #9ca3af;">language</mat-icon>
                  <div>
                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span style="font-family: monospace; font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">{{ r.countryCode }}</span>
                      <span *ngIf="isCountryInWhitelist(r.baseCountry || r.countryCode)"
                        title="País presente en el whitelist (vita_wallet_countries)"
                        style="background: #dcfce7; color: #15803d; padding: 1px 6px; border-radius: 999px; font-size: 0.62rem; font-weight: 700; letter-spacing: 0.5px;">
                        EN DB
                      </span>
                    </div>
                    <div style="font-size: 0.7rem; color: #6b7280; font-weight: 500;">{{ r.destLabel }}</div>
                  </div>
                </div>
              </td>
              <td style="padding: 8px 12px;">
                <div style="font-family: monospace; font-size: 0.78rem; color: #6b7280;">
                  1 <span style="font-weight: 700; color: #1e5a3f;">{{ r.sourceCurrency | uppercase }}</span> →
                </div>
                <div style="font-family: monospace; font-weight: 800; color: #166534; font-size: 0.9rem;">
                  {{ r.sellPrice | number:'1.2-8' }} <span style="font-size: 0.72rem; color: #6b7280;">{{ r.destCurrency }}</span>
                </div>
              </td>
              <td style="padding: 8px 12px; text-align: right;">
                <ng-container *ngIf="r.fixedCost > 0; else noFeeW">
                  <div style="font-weight: 700; color: #374151;">{{ r.fixedCost | number:'1.2-2' }} <span style="color: #6b7280; font-weight: 500; font-size: 0.72rem;">{{ r.destCurrency }}</span></div>
                  <div *ngIf="r.destCurrency !== 'USD' && r.fixedCostUsd > 0 && r.fixedCostUsd !== r.fixedCost" style="font-size: 0.68rem; color: #9ca3af; font-weight: 500;">
                    ≈ {{ r.fixedCostUsd | number:'1.2-2' }} USD
                  </div>
                </ng-container>
                <ng-template #noFeeW>
                  <span style="color: #16a34a; font-weight: 600; font-size: 0.78rem;">Sin fee</span>
                </ng-template>
              </td>
              <td style="padding: 8px 12px; text-align: right; color: #374151;">
                <span style="font-weight: 600;">{{ r.minAmount | number:'1.0-2' }}</span>
                <span style="color: #6b7280; font-size: 0.72rem; margin-left: 4px;">{{ r.sourceCurrency | uppercase }}</span>
              </td>
              <td style="padding: 8px 12px; text-align: center;">
                <span class="days-pill" [ngClass]="r.businessDays === 0 ? 'days-instant' : r.businessDays <= 1 ? 'days-fast' : 'days-slow'">{{ r.businessDays }}d</span>
              </td>
              <td style="padding: 8px 12px; text-align: center; background: #f0fdf4; border-left: 2px solid #bbf7d0;">
                <button type="button" (click)="simulateWithdrawal(r)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer;"
                  onmouseover="this.style.background='#15452f'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">calculate</mat-icon>
                  Simular
                </button>
              </td>
            </tr>
            <tr *ngIf="!pricesLoading && filteredWithdrawalRows.length === 0">
              <td colspan="6" style="padding: 30px; text-align: center; color: #6b7280;">
                <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #d1d5db; display: block; margin: 0 auto 6px;">search_off</mat-icon>
                Sin resultados
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Tab: Transferencias Vita -->
      <div *ngIf="pricesTab === 'vitasent'" style="border: 1px solid #e5e7eb; border-radius: 12px; overflow: auto; max-height: 520px;">
        <table style="width: 100%; border-collapse: collapse; font-size: 0.82rem;">
          <thead>
            <tr style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 2px solid #bbf7d0; position: sticky; top: 0; z-index: 1;">
              <th style="text-align: left; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Destino</th>
              <th style="text-align: left; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Tasa</th>
              <th style="text-align: right; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Fee</th>
              <th style="text-align: center; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase; background: #ecfdf5;">Simular</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of filteredVitaSentRows; let i = index; trackBy: trackByVitaSentRow" [style.background]="i % 2 === 0 ? 'white' : '#fafafa'" style="border-bottom: 1px solid #f3f4f6;">
              <td style="padding: 8px 12px; font-weight: 600; color: #374151;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <img *ngIf="r.flagIso as iso" [src]="'https://flagcdn.com/20x15/' + iso + '.png'" alt="" width="20" height="15"
                    style="border-radius: 2px; border: 1px solid #e5e7eb; flex-shrink: 0;" onerror="this.style.display='none'" />
                  <mat-icon *ngIf="!r.flagIso" style="font-size: 16px; width: 16px; height: 16px; color: #9ca3af;">language</mat-icon>
                  <div>
                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span style="font-family: monospace; font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">{{ r.countryCode }}</span>
                      <span *ngIf="isCountryInWhitelist(r.baseCountry || r.countryCode)"
                        title="País presente en el whitelist (vita_wallet_countries)"
                        style="background: #dcfce7; color: #15803d; padding: 1px 6px; border-radius: 999px; font-size: 0.62rem; font-weight: 700; letter-spacing: 0.5px;">
                        EN DB
                      </span>
                    </div>
                    <div style="font-size: 0.7rem; color: #6b7280; font-weight: 500;">{{ r.destLabel }}</div>
                  </div>
                </div>
              </td>
              <td style="padding: 8px 12px;">
                <div style="font-family: monospace; font-size: 0.78rem; color: #6b7280;">
                  1 <span style="font-weight: 700; color: #1e5a3f;">{{ r.sourceCurrency | uppercase }}</span> →
                </div>
                <div style="font-family: monospace; font-weight: 800; color: #166534; font-size: 0.9rem;">
                  {{ r.sellPrice | number:'1.2-8' }} <span style="font-size: 0.72rem; color: #6b7280;">{{ r.destCurrency }}</span>
                </div>
              </td>
              <td style="padding: 8px 12px; text-align: right;">
                <ng-container *ngIf="r.fixedCost > 0; else noFeeV">
                  <span style="font-weight: 700; color: #374151;">{{ r.fixedCost | number:'1.2-2' }}</span>
                  <span style="color: #6b7280; font-weight: 500; font-size: 0.72rem; margin-left: 4px;">{{ r.destCurrency }}</span>
                </ng-container>
                <ng-template #noFeeV>
                  <span style="color: #16a34a; font-weight: 600; font-size: 0.78rem;">Sin fee</span>
                </ng-template>
              </td>
              <td style="padding: 8px 12px; text-align: center; background: #f0fdf4; border-left: 2px solid #bbf7d0;">
                <button type="button" (click)="simulateVitaSent(r)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer;"
                  onmouseover="this.style.background='#15452f'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">calculate</mat-icon>
                  Simular
                </button>
              </td>
            </tr>
            <tr *ngIf="!pricesLoading && filteredVitaSentRows.length === 0">
              <td colspan="4" style="padding: 30px; text-align: center; color: #6b7280;">
                <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #d1d5db; display: block; margin: 0 auto 6px;">search_off</mat-icon>
                Sin resultados
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Tab: Payins -->
      <div *ngIf="pricesTab === 'payins'" style="border: 1px solid #e5e7eb; border-radius: 12px; overflow: auto; max-height: 520px;">
        <table style="width: 100%; border-collapse: collapse; font-size: 0.82rem;">
          <thead>
            <tr style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 2px solid #bbf7d0; position: sticky; top: 0; z-index: 1;">
              <th style="text-align: left; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">País</th>
              <th style="text-align: left; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Método</th>
              <th style="text-align: center; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Origen → Destino</th>
              <th style="text-align: right; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Sell price</th>
              <th style="text-align: right; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Fixed cost</th>
              <th style="text-align: right; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase;">Spread</th>
              <th style="text-align: center; padding: 10px 12px; color: #1e5a3f; font-size: 0.7rem; font-weight: 700; text-transform: uppercase; background: #ecfdf5;">Simular</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of filteredPayinRows; let i = index; trackBy: trackByPayinRow" [style.background]="i % 2 === 0 ? 'white' : '#fafafa'" style="border-bottom: 1px solid #f3f4f6;">
              <td style="padding: 8px 12px; font-weight: 600; color: #374151;">
                <img *ngIf="r.flagIso as iso" [src]="'https://flagcdn.com/20x15/' + iso + '.png'" alt="" width="20" height="15"
                  style="display: inline-block; vertical-align: middle; margin-right: 6px; border-radius: 2px; border: 1px solid #e5e7eb;" onerror="this.style.display='none'" />
                <mat-icon *ngIf="!r.flagIso" style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle; color: #9ca3af; margin-right: 6px;">language</mat-icon>
                <span [title]="r.destLabel" style="font-family: monospace; font-weight: 700; color: #1e5a3f;">{{ r.countryCode }}</span>
                <span *ngIf="isCountryInWhitelist(r.baseCountry || r.countryCode)"
                  title="País presente en el whitelist (vita_wallet_countries)"
                  style="background: #dcfce7; color: #15803d; padding: 1px 6px; border-radius: 999px; font-size: 0.62rem; font-weight: 700; letter-spacing: 0.5px; margin-left: 6px;">
                  EN DB
                </span>
              </td>
              <td style="padding: 8px 12px; font-weight: 600; color: #374151;">
                <span style="background: #eff6ff; color: #2563eb; padding: 2px 8px; border-radius: 8px; font-size: 0.72rem; font-weight: 700;">{{ r.paymentMethod }}</span>
              </td>
              <td style="padding: 8px 12px; text-align: center; font-family: monospace; font-size: 0.76rem; color: #6b7280;">
                {{ r.sourceCurrency | uppercase }} → {{ r.destinationCurrency | uppercase }}
              </td>
              <td style="padding: 8px 12px; text-align: right; font-weight: 700; color: #166534;">{{ r.sellPrice | number:'1.2-8' }}</td>
              <td style="padding: 8px 12px; text-align: right; color: #374151;">{{ r.fixedCost | number:'1.2-2' }}</td>
              <td style="padding: 8px 12px; text-align: right; color: #7c3aed; font-weight: 600;">
                {{ r.spread | number:'1.2-2' }}<span style="color: #9ca3af; font-weight: 400;">{{ r.spreadType === 'percentage' ? '%' : '' }}</span>
              </td>
              <td style="padding: 8px 12px; text-align: center; background: #f0fdf4; border-left: 2px solid #bbf7d0;">
                <button type="button" (click)="simulatePayin(r)"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer;"
                  onmouseover="this.style.background='#15452f'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">calculate</mat-icon>
                  Simular
                </button>
              </td>
            </tr>
            <tr *ngIf="!pricesLoading && filteredPayinRows.length === 0">
              <td colspan="7" style="padding: 30px; text-align: center; color: #6b7280;">
                <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #d1d5db; display: block; margin: 0 auto 6px;">search_off</mat-icon>
                Sin resultados
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="pricesLoading && withdrawalRows.length === 0" class="flex justify-center py-6">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    </div>
  </div>


</div>
